import _ from 'lodash';
import can from 'can';
import appContext from 'scripts/app-context';

import { getTooltipId } from '../tooltipHelpers';

import template from './chart.stache';
import drawChart from './chart-helpers/draw-chart';
import clearChart from './chart-helpers/clear-chart';
import { PRE_LABEL } from 'components/probability/computes/prepare-chart-data';
import { getPreTooltipText } from 'components/probability/tooltip-handler';
import dtm from 'scripts/services/dtm';

const axisY = ['0%', '25%', '50%', '75%', '100%', ''];

can.Component.extend({
    tag: 'probability-chart',
    template,
    viewModel: {
        define: {
            showVideo: {
                type: 'boolean',
                value: false,
            },
            data: {
                type: 'object',
                value: {},
            },
            round: {
                type: 'number',
                value: null,
            },
            axisX: {
                type: 'array',
                value: [],
            },
            axisY: {
                type: 'array',
                value: axisY,
            },
            pageType: {
                type: 'string',
            },
            refreshKey: {
                type: 'number',
            },
            tooltipText: {
                get() {
                    return getPreTooltipText(
                        this.attr('round'),
                        this.attr('pageType'),
                    );
                },
            },
        },
        hasVideo(hole) {
            const videos = this.data.videos;

            return Boolean(videos[hole]);
        },
        getVideoId(hole) {
            return _.get(this.data, `videos[${hole}].identifier`);
        },
        isPreLabel(val) {
            return val === PRE_LABEL;
        },
        play(hole) {
            const video = this.data.videos[hole];

            this.dispatch('onPlayClick', [hole, video]);
        },
        changeTooltipId(hole, prc) {
            this.attr(
                'activeTooltipId',
                getTooltipId(this.attr('round'), hole, prc),
            );
        },
        draw(chartContainer) {
            clearChart(chartContainer);

            if (!this.data || !this.data.points) {
                return;
            }

            drawChart(
                chartContainer,
                this.tooltip,
                this.data.serialize(),
                this.changeTooltipId.bind(this),
            );
        },
    },
    events: {
        inserted() {
            const chartContainer = this.element.find('.c-probability-chart');
            const xAxis = this.viewModel.attr('data.xAxis');

            if (xAxis) {
                this.viewModel.attr('axisX', xAxis);
            }

            this.viewModel.bind('data', (_, value) => {
                this.viewModel.attr('axisX', value.xAxis);
                this.viewModel.draw(chartContainer);
            });
            this.viewModel.bind('refreshKey', () => {
                this.viewModel.draw(chartContainer);
            });

            //dispatch event when axis was rendered
            this.viewModel.bind('axisX', () =>
                appContext.model.dispatch('chart-data-rendered'),
            );
        },
        '.js-tooltip-icon mouseenter'() {
            dtm.trackPreInfoButtonClick();
        },
    },
});
